// PGCET MCA Mock 8 — General English (questions 91–100)
const PASSAGE = "\"Libraries have long been (1) ______ as storehouses of human knowledge. In the digital age, however, many people now (2) ______ that they will soon become obsolete. Such fears are misplaced, for modern libraries offer free internet access, digital archives and quiet spaces for study.\"";

const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Choose the one word for: a person who does not believe in the existence of God.",
    options: ["A. Agnostic", "B. Atheist", "C. Theist", "D. Heretic"],
    answer: "B"
  },
  {
    id: 92,
    question: "Choose the one word for: a speech in a play in which a character, alone on stage, speaks his or her thoughts aloud.",
    options: ["A. Soliloquy", "B. Epilogue", "C. Dialogue", "D. Prologue"],
    answer: "A"
  },
  {
    id: 93,
    question: "Choose the one word for: a place where bees are kept.",
    options: ["A. Aviary", "B. Granary", "C. Aquarium", "D. Apiary"],
    answer: "D"
  },
  {
    id: 94,
    question: "Choose the correct passive form of: The committee will announce the results tomorrow.",
    options: [
      "A. The results would be announced by the committee tomorrow.",
      "B. The results are announced by the committee tomorrow.",
      "C. The results will be announced by the committee tomorrow.",
      "D. The results will have been announced by the committee tomorrow."
    ],
    answer: "C"
  },
  {
    id: 95,
    question: "Choose the correct passive form of the command: Open the door.",
    options: ["A. The door is opened.", "B. Let the door be opened.", "C. The door should open.", "D. Let the door is opened."],
    answer: "B"
  },
  {
    id: 96,
    question: "Choose the correct active form of: The thief was being chased by the police.",
    options: [
      "A. The police chased the thief.",
      "B. The police have chased the thief.",
      "C. The police had been chasing the thief.",
      "D. The police were chasing the thief."
    ],
    answer: "D"
  },
  {
    id: 97,
    question: "Choose the correct indirect speech of: She said to me, \"Where are you going?\"",
    options: [
      "A. She asked me where was I going.",
      "B. She asked me where I was going.",
      "C. She said to me where I am going.",
      "D. She asked me where I am going."
    ],
    answer: "B"
  },
  {
    id: 98,
    question: "Choose the correct indirect speech of: The teacher said to the students, \"Do not make a noise.\"",
    options: [
      "A. The teacher told the students not to make a noise.",
      "B. The teacher told the students do not make a noise.",
      "C. The teacher said to the students that they do not make a noise.",
      "D. The teacher told the students that not to make a noise."
    ],
    answer: "A"
  },
  {
    id: 99,
    question: `Cloze passage: ${PASSAGE} Choose the most appropriate word for blank (1).`,
    options: ["A. regarded", "B. disregarded", "C. regard", "D. regarding"],
    answer: "A"
  },
  {
    id: 100,
    question: `Cloze passage: ${PASSAGE} Choose the most appropriate word for blank (2).`,
    options: ["A. fears", "B. fearing", "C. fear", "D. to fear"],
    answer: "C"
  }
];

export default pgcetmcaGeneralEnglish;
